<template>
  <div v-if="logo">
    <img :src="logo.url" :alt="'Logo de ' + logo.nombre" :class="imageSize" />
  </div>
  <p v-else>Cargando logo...</p>
</template>

<script>
import ClienteService from "@/services/ClienteService";

export default {
  name: "Logos",
  props: {
    tamano: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      logo: null,
    };
  },
  computed: {
    imageSize() {
      return {
        "img-small": this.tamano === "small",
        "img-medium": this.tamano === "medium",
        "img-large": this.tamano === "large",
      };
    },
  },
  methods: {
    async fetchLogo() {
      try {
        const usuario = JSON.parse(localStorage.getItem("user")) || {};

        if (!usuario.id_cliente) {
          console.warn("Usuario no tiene cliente asignado.");
          return;
        }

        const response = await ClienteService.getClientes();
        let data = response.data.data;
        const clientes = Array.isArray(data) ? data : [data];

        const cliente = clientes.find(c => c.id === usuario.id_cliente);
        if (cliente && cliente.logo) {
          this.logo = {
            id: cliente.id,
            url: cliente.logo,
            nombre: cliente.nombre || "Cliente",
          };
        }
      } catch (error) {
        console.error("Error al obtener el logo:", error);
        this.logo = null;
      }
    },
  },
  mounted() {
    this.fetchLogo();
  },
};
</script>

<style scoped>
.img-small {
  width: 100px;
}

.img-medium {
  width: 40%;
}

.img-large {
  width: 100%;
}
</style>
